const axios = require('axios').default;

const api = axios.create({
    baseURL: cfpluginvars.api_uri,
    withCredentials: false,
    timeout: 5000,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
    }
})

export default api